var _style, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRainbow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1366 3",
    style: {
      enableBackground: "new 0 0 1366 3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#Ret\xE2ngulo_3897_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ret\\xE2ngulo_3897_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.8438,
    y1: 198.1493,
    x2: 263.8438,
    y2: 198.1493,
    gradientTransform: "matrix(1366 0 0 -3 -359045.125 595.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ECB460"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#D35F74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#CD6278"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    style: {
      stopColor: "#C5667F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    style: {
      stopColor: "#9E7B9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#6695C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    style: {
      stopColor: "#5E98CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76C6C7"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3897",
    x: -0.44,
    y: -0.14,
    className: "st0",
    width: 1366,
    height: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbow);
export default __webpack_public_path__ + "static/media/rainbow.ef08176f1628ef155f1135426c40b07a.svg";
export { ForwardRef as ReactComponent };